import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import Toast from "../../utils/toast";
import createInstance from "../../api/axiosinstance";
import "../commonLogin.css";
import { Button, TextField } from "@mui/material";

const ChangePassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const role = window.sessionStorage.getItem("role");
  console.log("ROLE", role);
  const aiDishaApi = createInstance("DISHA");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const validate = () => {
    if(!email){
      setErrors({
        ...errors,
        email : "Please enter a valid email id"
      })
      return false;
    }
    return true;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(validate()){
      setLoading(true);

      if(role === "Admin"){
        try {
          
          const response = await aiDishaApi.post(
            `/admin-user-Forget-Password-Email/?email=${email}`
          );
    
          if (response.status !== 200) {
            throw new Error("Email entered is incorrect or not registered");
          }
          Toast.success(response.data.message);
          navigate("/otpVerification", {
            state: {
              email,
              source: "forget-password", // Pass the source prop here
            },
          });
        } catch (error) {
          console.error("Error:", error);
          setErrors({ email: "Error sending OTP. Please try again." });
        } finally {
          setLoading(false); // Stop loading
        }
      }else if(role === "Interviewer" || role === "OrgAdmin" || role === "HR"){
        try {
          
          const response = await aiDishaApi.post(
            `/org-user-Forget-Password-Email/?email=${email}`
          );
    
          if (response.status !== 200) {
            throw new Error("Email entered is incorrect or not registered");
          }
          Toast.success(response.data.message);
          navigate("/otpVerification", {
            state: {
              email,
              source: "forget-password", // Pass the source prop here
            },
          });
        } catch (error) {
          console.error("Error:", error);
          setErrors({ email: "Error sending OTP. Please try again." });
        } finally {
          setLoading(false); // Stop loading
        }
      }
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-4">
      <h2 className="text-center gradient-text">Change Password</h2>
      <form
        onSubmit={handleSubmit}
        className="d-flex flex-column gap-4"
      >
        <p className="info-text">
        Enter Your Email to send one time Password
        
        </p>

        <TextField
          type="email"
          name="email"
          value={email}
          placeholder="Email ID"
          autoComplete="off"
          fullwidth
          onChange={handleChange}
          className="custom-textfield"
          required
          size="small"
        />
        {errors.email && <div style={{color:'red', fontSize:'12px'}}>{errors.email}</div>}

        <Button
          type="submit"
          className="gradient-button"
          disabled={loading} // Disable the button while loading
        >
          {loading ? <Loader /> : "Send OTP"}{" "}
        </Button>
      </form>
    </div>
    
  );
};

export default ChangePassword;